/**
 * Consider adding a short description of the feature flag and how it
 * will be used.
 *
 * If the feature flag is no longer in use, remove it from this enum.
 */
export var FeatureFlags;
(function (FeatureFlags) {
    /**/
    FeatureFlags["ShowDbtCloudProjectOption"] = "show-dbt-cloud-project-option";
    /* Show user groups */
    FeatureFlags["UserGroupsEnabled"] = "user-groups-enabled";
    /* Send local timezone to the warehouse session */
    FeatureFlags["EnableUserTimezones"] = "enable-user-timezones";
    /**
     * Enable dashboard comments
     */
    FeatureFlags["DashboardComments"] = "dashboard-comments-enabled";
    /**
     * Enable scheduler task that replaces custom metrics after project compile
     */
    FeatureFlags["ReplaceCustomMetricsOnCompile"] = "replace-custom-metrics-on-compile";
    /**
     * Enable the dynamic calculation of series color, when not manually set on the chart config.
     * This aims to make the colors more consistent, depending on the groups, but this could cause the opposite effect.
     * For more details, see https://github.com/lightdash/lightdash/issues/13831
     */
    FeatureFlags["CalculateSeriesColor"] = "calculate-series-color";
    /**
     * Enable the ability to write back custom bin dimensions to dbt.
     */
    FeatureFlags["WriteBackCustomBinDimensions"] = "write-back-custom-bin-dimensions";
    /**
     * Enable the ability to show the warehouse execution time and total time in the chart tile.
     */
    FeatureFlags["ShowExecutionTime"] = "show-execution-time";
    /**
     * Enable the ability to create custom visualizations with AI
     */
    FeatureFlags["AiCustomViz"] = "ai-custom-viz";
    FeatureFlags["BigquerySSO"] = "bigquery-sso";
    /**
     * Use workers for async query execution
     */
    FeatureFlags["WorkerQueryExecution"] = "worker-query-execution";
    /**
     * Enable SQL pivot results conversion to PivotData format
     */
    FeatureFlags["UseSqlPivotResults"] = "use-sql-pivot-results";
})(FeatureFlags || (FeatureFlags = {}));
export function isFeatureFlags(value) {
    return Object.values(FeatureFlags).includes(value);
}
//# sourceMappingURL=featureFlags.js.map